<template>
  <div class="parking-banner">
    <img :src="parkingBanner" alt="" />
    <div class="absolute">
      <div class="title">智能停车</div>
      <div class="text">
        智慧平台与停车场同步联动，随时查看停车场运行状态，车位是否停满、设备是否正常，停车场全局宏观调控，确保高峰畅行，再无堵车烦恼，实现停车场增值创收。
      </div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/pc/components/Experience.vue";

import parkingBanner from "../../../../assets/programme/parkingBanner.png";

export default {
  setup() {
    return reactive({
      parkingBanner: parkingBanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.parking-banner {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .parking-banner {
    min-width: 1180px;
  }
}
.parking-banner img {
  width: 100%;
  height: 368px;
}
.absolute {
  position: absolute;
  top: 50%;
  left: 36%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 40px;
}
.absolute .title {
  font-size: 30px;
  color: #248efb;
}
.absolute .text {
  width: 540px;
  font-size: 14px;
  margin-top: 20px;
  color: #248efb;
}
.absolute .experience {
  margin-top: 20px;
  font-size: 16px;
  color: #248efb;
  width: 108px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #248efb;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
}
</style>
